import React from 'react';
import {Form,Input,Radio,Button} from 'antd';
import UpPhoto from './Model/UpPhoto';
import cbhead from "../assets/images/cbhead.jpg";
import Axios from 'axios';
import {Redirect}from 'react-router-dom';
class News extends React.Component{

  constructor(props){
    super(props)
    //this.textRef = React.createRef()
   }

   state={
    regionName:"",
    regionId:"",
    label:"",
    parentText:"",
    countyName:"",
    countyId:"",
    //domain:'http://10.0.7.102:3005',
    domain:"",
    summitFlag:false

 }
  handleSubmit = e => {
    e.preventDefault();
    let url;
    let regionId;
    let regionName;
    let countyId;
    let countyName;
    let cbName;
    let cbType;
    let cbContent;
    let userId;
    this.props.form.validateFields((err, values) => {
      console.log(values);
      console.log(this.state.parentText);
       url =this.state.parentText;
       regionId = this.state.regionId;
       regionName =this.state.regionName;
       countyId = this.state.countyId;
       countyName =this.state.countyName;
       cbName =values.username;
       cbType = values.type;
       cbContent=values.area;
       userId = localStorage.getItem("userId");
      if(url===""||url===undefined){
        alert("照片不能为空")
        return;   
      }
      if (!err) {
        //Axios 请求 提交村宝信息到后台接口
        let api =this.state.domain+"/switch/treasure/save";
        var  params = new URLSearchParams();
        params.append("photo",url);
        params.append("regionId",regionId);
        params.append("regionName",regionName);
        params.append("countyId",countyId);
        params.append("countyName",countyName);
        params.append("name",cbName);
        params.append("tag",cbType);
        params.append("description",cbContent);
        //登录人ID
        params.append("adminId",userId);
        Axios.post(api,params)
        .then((res)=>{
           if(res.data.status===1){
            alert("提交成功");
            this.props.form.resetFields(); 
            localStorage.setItem("photo","");
            return;     
           }else{
             console.log(res.data.message);
             alert("提交失败");
             return;     
           }
        })
       .catch((error)=>{
           alert("提交失败");
           console.log(error);
           return;
       }) 
     }
    }); 
  };
 //组件将要挂载时候加载的生命周期函数
 componentWillMount(){
  localStorage.setItem("photo","");
  //市id
  let regionId = localStorage.getItem("regionId");
  let regionIdMd = localStorage.getItem("regionIdMd");
  //市名字
  let regionName = localStorage.getItem("regionName");
  //区ID
  let countyId = localStorage.getItem("countyId");
  //区名字
  let countyName = localStorage.getItem("countyName");
  let cbuserId =  localStorage.getItem("userId");
  console.log("regionName:["+regionName+"]");
  console.log("regionId:["+regionId+"]");
  console.log("cbuserId:["+cbuserId+"]");
  let lable ="非遗";
  //如果村宝用户id 不用空初始化 state 信息
  //aixo 请求
  this.setState({
    regionName:regionName,
    regionId:regionId,
    label:lable,//默认
    regionIdMd:regionIdMd,
    countyName:countyName,
    countyId:countyId
  })
 }

  //初始化组件信息
  componentDidMount(){
    console.log("04组件将要加载")
 }

  normFile = e => {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
 
  fn(data) {
    this.setState({
        parentText: data //把父组件中的parentText替换为子组件传递的值
    },() =>{
       console.log(this.state.parentText);//setState是异步操作，但是我们可以在它的回调函数里面进行操作
    });

}
  render(){ 
    const { getFieldDecorator } = this.props.form;
    const { TextArea } = Input;
    if(this.state.summitFlag){
      return <Redirect to={{pathname: `/login/${this.state.regionIdMd}`} }/>;
    };
    return(
        <div>  
        <img style={{width:'100%'}} src={cbhead} alt="村宝头部"/>  
       <Form  onSubmit={this.handleSubmit}>
       <Form.Item  labelCol={{ span: 6 }} wrapperCol={{ span: 3 }} label="姓名:">
          {getFieldDecorator('username', {
            initialValue:this.state.name,
            rules: [
              {
                required: true,
                message: '请输入名字',
              },
            ],
          })(<Input placeholder="请输入名字" />)}
        </Form.Item>
        <Form.Item labelCol={{ span: 6 }} wrapperCol={{ span: 3 }} label="头像:" >
          {getFieldDecorator('vi',{
                initialValue:"头像",
                rules: [
                  {
                    required: true,
                  },
                ],
              })(<UpPhoto pfn={this.fn.bind(this)}/>)}
         </Form.Item>
        <Form.Item  labelCol={{ span: 6 }} wrapperCol={{ span: 3 }} label="地点标签">
          <span className="ant-form-text">{this.state.countyName}</span>
        </Form.Item>
        <Form.Item   labelCol={{ span: 6 }} wrapperCol={{ span: 10 }} label="个人标签">
          {getFieldDecorator('type', {
            initialValue:this.state.label,
            rules: [
              {
                required: true,       
              },
            ],
          })(
            <Radio.Group>
              <Radio.Button value="非遗">非遗</Radio.Button>　
              <Radio.Button value="戏曲">戏曲</Radio.Button>　
              <Radio.Button value="舞蹈/歌曲">舞蹈/歌曲</Radio.Button>　
              <Radio.Button value="相声/小品">相声/小品</Radio.Button>　
              <Radio.Button value="民俗">民俗</Radio.Button>　
              <Radio.Button value="音乐">音乐</Radio.Button>　
              <Radio.Button value="美术/书法">美术/书法</Radio.Button>
            </Radio.Group>,
          )}
        </Form.Item>
        <Form.Item  labelCol={{ span: 6 }} wrapperCol={{ span: 10 }} label="村宝简介">
        {getFieldDecorator('area',{
          initialValue:this.state.content,
          rules :[
              {
                required: true,
                message: '请输入村宝介绍',
             }
          ],
        })(
          <TextArea  rows={5} />
          )}
        </Form.Item>
        <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
          <Button type="primary" htmlType="submit">
            提交信息
          </Button>　　　
        </Form.Item>
      </Form>
          </div>
    )
  }
}
const WrappedNew = Form.create({ name: 'validate_other' })(News);
export default WrappedNew;


// WEBPACK FOOTER //
// ./src/components/News.js